import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { MuelleListResponse } from '../../shared/interfaces/muelle.interface';

@Injectable({ providedIn: 'root' })
export class MuelleService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/muelle`;

  listar(params: { page: number; limit: number; q?: string }): Observable<MuelleListResponse> {
    const httpParams: Record<string, string> = {
      page: String(params.page),
      limit: String(params.limit),
    };
    if (params.q) {
      httpParams['q'] = params.q;
    }
    return this.http.get<MuelleListResponse>(this.apiUrl, { params: httpParams });
  }

  contactar(id: string): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(`${this.apiUrl}/${id}/contacto`, {});
  }

  cancelarContacto(id: string): Observable<{ success: boolean }> {
    return this.http.delete<{ success: boolean }>(`${this.apiUrl}/${id}/contacto`);
  }

  agregarACelula(id: string): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(`${this.apiUrl}/${id}/celula`, {});
  }
}
